<div class="container mt-3" id="container">
  <div data-size="A4">
    <div class="row">
      <div class="col" id="title-container">
        <h2>Preparation Paper</h2>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <ul class="list-group list-group-horizontal">
          <li class="list-group-item justify-content-between col-4">
            <strong>Event name</strong><br />
            <span>[{{event.id}}] {{event.eventName}}</span>
          </li>
          <li class="list-group-item justify-content-between col-2">
            <strong>Start Date</strong><br />
            <span>{{event.startDate | date:'dd-MM-yyyy'}}</span>
          </li>
          <li class="list-group-item justify-content-between col-2">
            <strong>Pickup Date</strong><br />
            <span>{{event.pickUpDate | date:'dd-MM-yyyy'}}</span>
          </li>
          <li class="list-group-item justify-content-between col-2">
            <strong>Organization</strong><br />
            <span>{{event.clientUser.company.name}}</span>
          </li>
          <li class="list-group-item justify-content-between col-2">
            <strong>Client name</strong><br />
            <span>{{event.clientUser.firstName}} {{event.clientUser.lastName}}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <table class="table table-bordored">
          <thead>
            <tr>
              <th class="text-uppercase" style="color: black; width: 55%;">Hardware</th>
              <th class="text-uppercase text-center" style="color: black; width: 15%;">Qty</th>
              <th class="text-uppercase text-center" style="color: black; width: 15%;">preprared Qty</th>
              <th class="text-uppercase text-center" style="color: black; width: 15%;">preprared</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let deviceUser of event.deviceUsers">
              <tr>
                <td>{{deviceUser.device.deviceType.name}} <strong>{{deviceUser.device.name}}</strong></td>
                <td class="text-center">1</td>
                <td class="text-center"><span class="fake-checkbox"></span></td>
                <td class="text-center"><span class="fake-checkbox"></span></td>
              </tr>
              <tr *ngIf="deviceUser.device.deviceType.id === 1">
                <td>Phone charger</td>
                <td class="text-center">1</td>
                <td class="text-center"><span class="fake-checkbox"></span></td>
                <td class="text-center"><span class="fake-checkbox"></span></td>
              </tr>
              <tr *ngIf="deviceUser.device.deviceType.id === 2">
                <td>Tablet charger</td>
                <td class="text-center">1</td>
                <td class="text-center"><span class="fake-checkbox"></span></td>
                <td class="text-center"><span class="fake-checkbox"></span></td>
              </tr>
            </ng-container>
            <ng-container *ngFor="let router of event.routers">
              <tr>
                <td>Router <strong>{{router.name}}</strong></td>
                <td class="text-center">1</td>
                <td class="text-center"><span class="fake-checkbox"></span></td>
                <td class="text-center"><span class="fake-checkbox"></span></td>
              </tr>
              <tr>
                <td>Router power adapter</td>
                <td class="text-center">1</td>
                <td class="text-center"><span class="fake-checkbox"></span></td>
                <td class="text-center"><span class="fake-checkbox"></span></td>
              </tr>
            </ng-container>
            <ng-container *ngFor="let printer of event.printers">
              <tr>
                <td>Printer <strong>{{printer.name}}</strong></td>
                <td class="text-center">1</td>
                <td class="text-center"><span class="fake-checkbox"></span></td>
                <td class="text-center"><span class="fake-checkbox"></span></td>
              </tr>
              <tr>
                <td>Printer power adapter</td>
                <td class="text-center">1</td>
                <td class="text-center"><span class="fake-checkbox"></span></td>
                <td class="text-center"><span class="fake-checkbox"></span></td>
              </tr>
            </ng-container>
            <tr *ngFor="let cable of cablesAmount">
              <td>Cable <strong>{{cable.length}}M</strong></td>
              <td class="text-center">{{cable.amount}}</td>
              <td class="text-center"><span class="fake-checkbox"></span></td>
              <td class="text-center"><span class="fake-checkbox"></span></td>
            </tr>
            <ng-container *ngIf="event.printers && event.printers.length > 0 ">
              <tr>
                <td>paper rolls</td>
                <td class="text-center">{{event.printers.length * 2}}</td>
                <td class="text-center"><span class="fake-checkbox"></span></td>
                <td class="text-center"><span class="fake-checkbox"></span></td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <ul class="list-group">
          <li class="list-group-item"><strong class="text-uppercase">Notes</strong><br />
            <textarea class="form-control" rows="10"></textarea>
          </li>
        </ul>
      </div>
      <div class="col">
        <ul class="list-group">
          <li class="list-group-item"><strong class="text-uppercase">Preparer Name</strong><br /><br /><br /></li>
          <li class="list-group-item mt-3"><strong class="text-uppercase">Signature</strong><br /><br /><br /></li>
        </ul>
      </div>
    </div>
  </div>
</div>